import React, { useState, useEffect } from "react";
import {
  IonButton,
  IonContent,
  IonPage,
  IonInput,
  IonItem,
  IonLabel,
  useIonViewWillEnter,
} from "@ionic/react";

import "./ForgotPassword.scss";
import { forgotService } from "./ForgotPassword.service";
import { ForgotPasswordUserResult } from "./ForgotPassword.model";

import {  useLocation } from "react-router";
import { useTranslation } from "react-i18next";

import Loader from "../../components/Shared/Loader/Loader";
import { AuthService } from "../../services/authService";


const Forgotpasswordpage: React.FC = () => {
  const { t } = useTranslation("login");

  const [username, setUsername] = useState("");
  const [isFormValid, setFormStatus] = useState(false);
  const [isLoaderActive, setLoaderStatus] = useState(false);
  const [forgotStatus, setForgotStatus] = useState("");
  const [responseStatus, setResponseStatus] = useState(false);
  const [network, setNetwork] = useState("");
  const [isEmailNotValid, setIsEmailValid]= useState(false);

  const location = useLocation();
  const forgotPassword = "forgot-password";
  const forgotUsername = "forgot-username";

  useIonViewWillEnter(() => {
    AuthService.clearStorage();
  });

  useEffect(() => {
    setFormStatus(formValidation());
  }, [username,network]);

  const formValidation = () => {
    if(username && network) {
        return true;
    } else {
      return false;
    }
  };

 

  async function onSubmit(e: any) {
    e.preventDefault();
    const currentLocation: any = location;
    let redirectedFrom = currentLocation.state?.buttonDetails;
    let isEmailValid = getPassword(username);
    setLoaderStatus(true);
    if (isEmailValid) {
      let params: any = { email: username, reg_code: network };
      setResponseStatus(false);

      if(redirectedFrom === forgotPassword){
        let respResult: ForgotPasswordUserResult = await forgotService.forgot(
          params
        );
        if (respResult.isSuccess) {
          setResponseStatus(true);
          setForgotStatus(respResult.message);
        } else {
          setForgotStatus(respResult.message);
        }
      } else if(redirectedFrom === forgotUsername){
        let respResult: ForgotPasswordUserResult = await forgotService.forgotUsername(
          params
        );
        if (respResult.isSuccess) {
          setResponseStatus(true);
          setForgotStatus(respResult.message);
        } else {
          setForgotStatus(respResult.message);
        }
      }
    }
    setLoaderStatus(false);
  }

  const getPassword= (email: any) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValidEmail = re.test(email);
    if(isValidEmail){
      setIsEmailValid(false);
    } else {
      setIsEmailValid(true);
    }
     return isValidEmail;
  }

  const clearData = () => {
    setNetwork("");
    setUsername("");
    setForgotStatus("");
    setIsEmailValid(false);
  }

  const getByLabel = () => {
      const currentLocation: any = location;
      let redirectedFrom = currentLocation.state?.buttonDetails;
      if(redirectedFrom === forgotPassword){
        return t("resetYourPassword");
      } else if(redirectedFrom === forgotUsername){
        return t("knowYourUsername");
      }
  }

  return (
    <IonPage>
      <IonContent>
        <div className="login-container">
          <div className="login-input-container">
            <div className="callcentral-logo-container">
              <div className="logo-wrapper">
                <img
                  className="callcentral-logo"
                  src="assets/icon/logoIcon.svg"
                  alt="Nserix"
                />
                
              </div>
            </div>

            <div className="login-input-wrapper">
              {isLoaderActive && (
                <div className="loader-container">
                  <Loader></Loader>
                </div>
              )}

              <div className="login-input-header">
                <div className="welcome-wrapper">
                  <span className="welcome">{t('welcome')}</span>
                </div>
                <br></br>
                <span className="header-title">
                  {t('enterEmailTo')}{getByLabel()}.
                </span>
              </div>
              <form name="form" onSubmit={onSubmit}>
                <div className="item-input-wrapper">
                  <div className="input-icon icon-name"></div>
                  <IonItem className="item-input">
                    <IonLabel className="item-label" position="floating">
                      {t('email')}
                    </IonLabel>
                    <IonInput
                      className="ion-input"
                      name=" Username"
                      value={username}
                      // onIonChange={handleChange}
                      onIonInput={(e: any) =>  {
                        setUsername(e.target.value);
                        setIsEmailValid(false);
                      } 
                      }
                    >
                      {" "}
                    </IonInput>
                  </IonItem>
                  {isEmailNotValid && (
                    <div className="validation-message">{t('pleaseProvideValidEmail')}</div>
                  )}
                </div>
                <div className="item-input-wrapper">
                  <div className="input-icon icon-network"></div>
                  <IonItem className="item-input">
                    <IonLabel className="item-label" position="floating">
                      {t('network')}
                    </IonLabel>
                    <IonInput
                      className="ion-input"
                      name="network"
                      value={network}
                      onIonInput={(e: any) => setNetwork(e.target.value)}
                    >
                      {" "}
                    </IonInput>
                  </IonItem>
                  {!username && (
                    <div className="invalid-feedback">{t('usernameRequired')}</div>
                  )}
                </div>

                <div className="messageStatus">
                  <span className={` ${responseStatus ? "success" : "error"}`}>
                    {forgotStatus}
                  </span>
                </div>

                <div className="action-button-container">
                  <IonButton
                    className="button secondary-btn login-btn btn-curved"
                    routerLink="/login"
                    onClick={(e)=>{clearData()}}
                  >
                    {t('cancel')}
                  </IonButton>

                  <IonButton
                    className="button primary-btn login-btn btn-curved"
                    onClick = {(e)=>{onSubmit(e)}}
                    disabled={!isFormValid}
                  >
                    {t('submit')}
                  </IonButton>
                </div>
              </form>
            </div>
          </div>

          <div className="loginbg-container">
            <div className="bgimage-text-wrapper">
              <span className="white-text">
                {t('oneStopSolution')}<br></br>
              </span>
              <span className="white-text">
                {t('platformIndependent')}<br></br>
              </span>
              <span className="green-text">
                {t('doctorManagement')}<br></br>
              </span>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Forgotpasswordpage;
